import DashboardLayout from "../../../Layouts/Dashboard/dashboard";
import moment from "moment";
import TableSkeleton from "../../../Components/Table/TableSkeleton";
import { orderService } from "../../../Core/Api/services";
import { DbOrderItemInfos } from "../../../Core/Api/Types/db-order-item-infos";
import OrderTable, { OrderTableContext } from "../../../Components/Table/OrdersTable/orders-table";
import { FC } from "react";
import React from "react";

interface OrderListBasicProps {}

const OrderListBasic: FC<OrderListBasicProps> = (props) => {
  const [isLoading, setLoading] = React.useState(true);
  const [rows, setData] = React.useState<DbOrderItemInfos[]>([]);

  // Fetching data
  React.useEffect(() => {
    const start = moment().add(-15, "d").format("YYYY-MM-DD");
    const end = moment().add(1, "d").format("YYYY-MM-DD");

    orderService.GetItemsListByDate(start, end).then(function (response) {
      setData(response.items);
      setLoading(false);
    });
  }, []);

  return (
    <DashboardLayout sxContent={{ px: 2 }}>
      {isLoading ? <TableSkeleton /> : <OrderTable context={OrderTableContext.Basic} orders={rows} />}
    </DashboardLayout>
  );
};

export default OrderListBasic;
